import Vue from 'vue'
import Element from 'element-ui'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import trLocale from 'element-ui/lib/locale/lang/tr-TR'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

import arLocale from 'element-ui/lib/locale/lang/ar'
// import arSALocale from 'element-ui/lib/locale/lang/ar-SA'
// import hiAELocale from 'element-ui/lib/locale/lang/hi-AE'
import idLocale from 'element-ui/lib/locale/lang/id'
// import urSALocale from 'element-ui/lib/locale/lang/ur-AE'
import en from './en_US'
import zh from './zh_CN'
import tr from './tr_TR'


import ae from './ar-AE'
import ar from './ar-SA'
import hi from './hi-AE'
import id from './id-ID'
import ur from './ur-AE'


import { LOCALE_STORE_KEY } from '../constant'
import { getLocal } from '@meta-vue/util'
Vue.use(VueI18n)

const messages = {
  'zh-CN': {
    language: '简体中文',
    ...zh,
    ...zhLocale
  },
  'en-US': {
    language: 'English',
    ...en,
    ...enLocale
  },
  'tr-TR': {
    language: '土耳其',
    ...tr,
    ...trLocale
  },
  'ar-AE': {
    language: '阿拉伯语',
    ...ae,
    ...arLocale
  },
 'hi-AE': {
    language: '印地语',
    ...hi,
  },
'id-ID': {
    language: '印尼语',
    ...id,
    ...idLocale
  },
'ur-AE':{
    language: '乌尔都语',
    ...ur,
  },
}

export function getDefaultLanguage() {
  const commandInfo = getLocal(LOCALE_STORE_KEY)
  let lang
  if (commandInfo) {
    lang = commandInfo.lang
  }
  return lang || 'en-US'
}
const i18n = new VueI18n({
  locale: getDefaultLanguage(), // set locale
  messages, // set locale messages
  silentTranslationWarn: true, //解决vue-i18n黄色警告"value of key 'xxx' is not a string"和"cannot translate the value of keypath 'xxx'.use the value of keypath as default",可忽略
  globalInjection: true, // 全局注入
  fallbackLocale: 'zh-CN' // 指定的locale没有找到对应的资源或当前语种不存在时，默认设置当前语种为中文
})

console.log(i18n, getDefaultLanguage(), 'i18ni18ni18n')

locale.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})

// 导出messages 给切换语言的时候用
export { i18n, messages }
